import client from './client';
import { StatsSummary } from '../types';

export const getSummary = async (params: {
  apartment_id?: string;
  start_date?: string;
  end_date?: string;
} = {}): Promise<StatsSummary> => {
  const res = await client.get('/api/v1/stats/summary', { params });
  return res.data;
};
